import getConfig from 'next/config';

const { CORE_URL } = getConfig().publicRuntimeConfig;

export const autoFormRedirectHandler = (data) => {
  const queryParams = new URLSearchParams({
    namePlan: data.namePlan,
    year: data.year,
    category: data.category,
    area: data.area,
    phoneNumber: data.phoneNumber,
    email: data.email,
    name: `${data.firstName} ${data.lastName}`,
    step: '2'
  });

  window.location.href = `${CORE_URL}/search?${queryParams.toString()}`;
};
